import { Component, ElementRef, ViewChild} from "@angular/core";
import 'rxjs/add/operator/finally';
import {
	NavController,
	ModalController,
	AlertController,
	LoadingController,
	ViewController,
	NavParams,
	Platform,
	Events,
} from "ionic-angular";

// O provider para se comunicar com o servidor online
import { ApiProvider } from "../../providers/api/api";

// Salvar no storage
import { Storage } from "@ionic/storage";

import { CartaofidelidadePage } from "../cartaofidelidade/cartaofidelidade";
import { MensagemPontoPage } from "../mensagem-ponto/mensagem-ponto";
import { MensagensPage } from "../mensagens/mensagens";

import { LinguaPage } from "../lingua/lingua";

import QrScanner from '../../qr-scanner.min.js'; // if using plain es6 import

// import { QRScanner, QRScannerStatus } from "@ionic-native/qr-scanner";
// QrScanner.WORKER_PATH = 'qr-scanner/qr-scanner-worker.min.js';
// import QrScannerWorkerPath from 'qr-scanner/qr-scanner-worker.min.js';
// QrScanner.WORKER_PATH = QrScannerWorkerPath;


import { TranslateMsgProvider } from "../../providers/translate-msg/translate-msg";
import { TranslateService } from "@ngx-translate/core";
import { l } from "@angular/core/src/render3";
import { utf8Encode } from "@angular/compiler/src/util";

@Component({
	selector: "page-home",
	templateUrl: "home.html",
})
export class HomePage {
  modalEndereco;
  endereco = { uf: "", cidade: "" };
  id_cliente = 0;
  preencheuEnd = false;
  empresas;
  pagina = 0;
  carregando = true;
  plataforma = '';
  id_empresa = '';

  constructor(
    public  navCtrl    : NavController,
    public  modalCtrl  : ModalController,
    private storage    : Storage,
    private loadingCtrl: LoadingController,
    private _api       : ApiProvider,
    private alertCtrl  : AlertController,
    private _msg       : TranslateMsgProvider,
    public  translate  : TranslateService,
    public  platform   : Platform,
    public  events     : Events
  ) {
    this.events.unsubscribe("gotopage2");

    this.events.subscribe("gotopage2", (dados) => {
      this.storage.set("id_empresa_escolhida", dados.id);
      this.navCtrl.push(dados.page);
    });
  }

  ionViewDidEnter() {

    this.storage.get("mensagem").then((msg) => {
      if (msg == 1) {
        this.storage.set("mensagem", 0);
      } else {
        this.storage.set("id_empresa_escolhida", 0);
        this.iniciaPagina();
      }
    });
  }

  ionViewDidLeave() {
    this.carregando = true;
    this.empresas = [];
  }

  iniciaPagina() {
	const urlParams = new URLSearchParams(window.location.search);
	this.id_empresa = urlParams.get('id_empresa_inicial');
	if(this.id_empresa){
		this.abrirEmpresa(this.id_empresa);
	}

    if (this.translate.getDefaultLang() == null) {
      let modalLng = this.modalCtrl.create(LinguaPage);
      modalLng.onDidDismiss((data) => {
        this.iniciaPagina();
      });
      modalLng.present();
    } else {
      this.storage.get("id_cliente").then((val) => {
        this.id_cliente = val;
        this.preencheuEnd = true;
        this.pagina = 0;
        this.getMinhasLojas();

        this.storage.get("tokenpush").then((tok) => {

		  this.plataforma = JSON.stringify(this.platform.platforms());
          let dadosT;

          if (this.platform.is("ios")) {
            dadosT = { token: tok, id: this.id_cliente, platform: "ios" };
          } else {
            dadosT = { token: tok, id: this.id_cliente, platform: "android" };
          }
          this._api.token(dadosT).subscribe((arg3) => { });

		  this._api.changeLanguage({id: this.id_cliente, lng2: this.translate.getDefaultLang()}).subscribe(arg1=>{});

          // this.abrirEmpresa(2447);
          this.storage.get('whatsapp').then((whatsapp) => {
            if (whatsapp) {
				var whatsapptoken = this.platform.getQueryParam("whatsapptoken");
				this.storage.set('whatsapp', 0);

				this._api.getMyPoint({ token: whatsapptoken, id_cliente: this.id_cliente}).subscribe((result) => {

					window.history.replaceState(null, null, window.location.pathname);
					if(result.sucesso == 1){
						this.storage.set('result-id_empresa', result.id_empresa);
						this.storage.set('result-message', result.message);
						this.abrirMensagemPonto(result.id_empresa);
					}
				});

            }
          });
        });
      });
    }
  }

  // Retorna as empresas relacionadas com esse cliente
  getMinhasLojas() {
    this._api
      .getMinhasLojas({ id_cliente: this.id_cliente, pagina: this.pagina })
      .subscribe((arg) => {
        this.pagina++;
        this.carregando = false;
        if (arg.empresas.length > 0) {
          this.empresas = arg.empresas;
        } else {
          this.maisEmpresa();
        }
      });
  }

  doInfinite(infiniteScroll) {
    this._api
      .getMinhasLojas({ id_cliente: this.id_cliente, pagina: this.pagina })
      .subscribe((arg) => {
        this.pagina++;

        for (var i = 0; i < arg.empresas.length; ++i) {
          this.empresas.push(arg.empresas[i]);
        }

        infiniteScroll.complete();

        if (!arg.maisitens) infiniteScroll.enabled = false;
        else infiniteScroll.enabled = true;
      });
  }

  // Abrir empresas
  abrirEmpresa(id) {

    this.storage.set("id_empresa_escolhida", id);
    this.navCtrl.push(CartaofidelidadePage);
  }

  abrirMensagemPonto(id) {
    this.storage.set("id_empresa_escolhida", id);
    this.navCtrl.push(MensagemPontoPage);
  }

  // Adicionar mais empresa
  maisEmpresa() {
    // this.navCtrl.push(MaisempresaPage, {id_cliente: this.id_cliente});
    this.events.publish("gotobusca");
  }
}

@Component({
	selector: "page-homeendereco",
	templateUrl: "homeendereco.html",
})
export class HomeenderecoPage {
	estados;
	todascidades;
	cidades;
	escolhido = { uf: "", cidade: "" };

	constructor(
		public navCtrl: NavController,
		private _api: ApiProvider,
		private alertCtrl: AlertController,
		private loadingCtrl: LoadingController,
		public viewCtrl: ViewController,
		private _msg: TranslateMsgProvider
	) {
		let loading = this.loadingCtrl.create({
			content: this._msg.getMsg("CARREGANDO") + "...",
			dismissOnPageChange: true,
		});
		loading.present();
		this._api.getEnderecosMarketplace().subscribe((arg) => {
			loading.dismiss();
			this.estados = arg.estados;
			this.todascidades = arg.cidades;
		});
	}

	mudaUf() {
		this.cidades = [];
		for (let i = 0; i < this.todascidades.length; i++) {
			if (this.todascidades[i].uf == this.escolhido.uf) {
				this.cidades.push(this.todascidades[i]);
			}
		}
	}

	verlojas() {
		if (this.escolhido.uf == "") {
			let alert = this.alertCtrl.create({
				title: "Ops",
				subTitle: this._msg.getMsg("CARTAO_ESCOLHA_ESTADO"),
				buttons: [
					{
						text: "OK",
						role: this._msg.getMsg("CANCELAR"),
					},
				],
			});
			alert.present();
		} else if (this.escolhido.cidade == "") {
			let alert = this.alertCtrl.create({
				title: "Ops",
				subTitle: this._msg.getMsg("CARTAO_ESCOLHA_CIDADE"),
				buttons: [
					{
						text: "OK",
						role: this._msg.getMsg("CANCELAR"),
					},
				],
			});
			alert.present();
		} else {
			this.viewCtrl.dismiss(this.escolhido);
		}
	}
}

@Component({
	selector: "page-tutorialqrcode",
	templateUrl: "tutorialqrcode.html",
})
export class TutorialqrcodePage {
	vertutorial  = false;
	inicio       = false;
	qrcode       = false;
	showTutorial = false;
	camHasCamera = 'false';
	camHasFlash  = 'false';
	qrcode_image;
	scannerHtml;
	resultQrcode = '';
	// video        = false;

	@ViewChild('videoScanner') video: ElementRef;

	

	constructor(
		public viewCtrl: ViewController,
		// private qrScanner: QRScanner,
		        params  : NavParams,
		private platform: Platform,
		private navCtrl: NavController,
		private storage : Storage
	) {
		this.storage.get("tutorialqrcode").then((val1) => {
			this.vertutorial = val1;
			this.inicio = val1;
			this.showTutorial = !val1;
		});

		this.platform.registerBackButtonAction(() => {
            this.navCtrl.setRoot(HomePage);
        }, 1);
	}

	private showCamera() {
		((<any>window).document.querySelector("ion-app") as HTMLElement).classList.add("cameraView");
		((<any>window).document.querySelector("body") as HTMLElement).classList.add("qr-scanner");
	}
	private hideCamera() {
		((<any>window).document.querySelector("ion-app") as HTMLElement).classList.remove("cameraView");
		((<any>window).document.querySelector("body") as HTMLElement).classList.remove("qr-scanner");
		document.querySelector("body > canvas").remove();
	}

	lerQrCode() {
		console.log('Iniciando lerQrCode');
		this.qrcode = true;
		QrScanner.hasCamera().then(hasCamera => this.camHasCamera = hasCamera);

		const scanner = new QrScanner('NULL', result => {
			this.resultQrcode = JSON.stringify(result);
			this.hideCamera();
			scanner.stop();
			if(result != ""){
				this.viewCtrl.dismiss({text: result});
			}
		}, error => {
			this.resultQrcode = JSON.stringify(error);
		});

		scanner.start().then(() => {
			this.showCamera();
			((<any>window).document.querySelector("ion-app") as HTMLElement).parentNode.insertBefore(scanner.$canvas, ((<any>window).document.querySelector("ion-app") as HTMLElement));
		});

		
	}

	imageFilePath_change(event){

		const file = event.target.files[0];

        if (!file) {
            return;
        }
        QrScanner.scanImage(file)
            .then(result => {

				if(result != ""){
					this.viewCtrl.dismiss({text: result});
				}
			})
            .catch(e => console.error( e || 'No QR code found.'));
	}



	ngAfterViewInit() {
		var input = document.getElementById('qr-video');
		console.warn('input',input);
	}

	// Muda a session de tutorial
	updateSessionTutorial() {
		this.storage.set("tutorialqrcode", this.vertutorial);
		this.showTutorial = !this.vertutorial;
		console.log('Checkbox actualizado: showTutorial=', this.showTutorial, 'qrcode=', this.qrcode);
		if (!this.showTutorial) {
			this.lerQrCode();
		}
	}

	vertutorialnovamente() {
		this.vertutorial = false;
		this.inicio = false;
		this.updateSessionTutorial();
	}

	ionViewDidEnter() {
		if (!this.showTutorial) {
			this.lerQrCode();
		}
	}
}

@Component({
	selector: "page-maisempresa",
	templateUrl: "maisempresa.html",
})
export class MaisempresaPage {
	carregando = false;
	busca = "";
	id_cliente = 0;
	pagina = 0;
	empresas = [];
	showfiltros = false;
	opcoesFiltros = [];
	filtrosSelecionados = {};
	temFiltro = false;
	totalempresas;
	fezBusca = false;
	fraseerro = "";

	constructor(
		public navCtrl: NavController,
		private _api: ApiProvider,
		public params: NavParams,
		private storage: Storage,
		public events: Events
	) {
		this.id_cliente = params.get("id_cliente");
	}

	ionViewDidEnter() {
		this.events.unsubscribe("gotopage3");
		this.events.subscribe("gotopage3", (dados) => {
			this.storage.set("id_empresa_escolhida", dados.id);
			this.navCtrl.push(dados.page);
		});

		this.storage.set("id_empresa_escolhida", 0);
	}

	iniciaFiltros() {
		for (var i = 0; i < this.opcoesFiltros.length; ++i) {
			if (this.opcoesFiltros[i].tipo == "checkbox") {
				this.filtrosSelecionados[this.opcoesFiltros[i].nome] = false;
			} else if (
				this.opcoesFiltros[i].tipo == "range" &&
				this.opcoesFiltros[i].dualknobs
			) {
				this.filtrosSelecionados[this.opcoesFiltros[i].nome] = {
					lower: this.opcoesFiltros[i].min,
					upper: this.opcoesFiltros[i].max,
				};
			} else {
				this.filtrosSelecionados[this.opcoesFiltros[i].nome] = "";
			}
		}

		this.carregando = false;
	}

	abrirEmpresa(id) {
		this.storage.set("id_empresa_escolhida", id);
		this.navCtrl.push(CartaofidelidadePage);
	}

	buscaEmpresa() {
		this.carregando = true;
		this.pagina = 0;
		this.empresas = [];
		this.temFiltro = false;
		this.fazBusca();
	}

	fazBusca() {
		this.pagina = 0;
		if (this.busca == "") {
			this.carregando = false;
			this.empresas = [];
			this.fezBusca = false;
			return false;
		}

		this.fezBusca = true;

		let dados;

		if (this.temFiltro) {
			dados = {
				busca: this.busca,
				id_cliente: this.id_cliente,
				pagina: this.pagina,
				filtros: this.filtrosSelecionados,
			};
		} else {
			dados = {
				busca: this.busca,
				id_cliente: this.id_cliente,
				pagina: this.pagina,
			};
		}

		this._api.getEmpresasBusca(dados).subscribe((arg) => {
			this.totalempresas = arg.totalEmpresas;
			this.empresas = arg.empresas;
			this.fraseerro = arg.fraseerro;
			this.carregando = false;
			this.pagina++;
		});
	}

	doInfinite(infiniteScroll) {
		if (this.busca == "") {
			this.carregando = false;
			this.empresas = [];
			this.pagina = 0;
			infiniteScroll.complete();
			return false;
		}

		let dados;

		if (this.temFiltro) {
			dados = {
				busca: this.busca,
				id_cliente: this.id_cliente,
				pagina: this.pagina,
				filtros: this.filtrosSelecionados,
			};
		} else {
			dados = {
				busca: this.busca,
				id_cliente: this.id_cliente,
				pagina: this.pagina,
			};
		}

		this._api.getEmpresasBusca(dados).subscribe((arg) => {
			this.pagina++;
			for (var i = 0; i < arg.empresas.length; ++i) {
				this.empresas.push(arg.empresas[i]);
			}

			infiniteScroll.complete();

			if (!arg.maisitens) infiniteScroll.enabled = false;
			else infiniteScroll.enabled = true;
		});
	}

	filtros() {
		this.carregando = true;
		this.showfiltros = true;
		this._api.getFiltrosEmpresas({ busca: this.busca }).subscribe((arg) => {
			this.opcoesFiltros = arg.filtros;
			this.iniciaFiltros();
		});
	}

	cancelarFiltros() {
		this.showfiltros = false;
	}

	funcApi(filtro) {
		// Verifica se tem funcao ao mudar valor
		if (filtro.funcao != "") {
			this._api
				.getFiltroFuncao({
					funcaoFiltro: filtro.funcao,
					valor: this.filtrosSelecionados[filtro.nome],
					busca: this.busca,
				})
				.subscribe((arg) => {
					for (var i = 0; i < this.opcoesFiltros.length; ++i) {
						if (this.opcoesFiltros[i].nome == filtro.prop) {
							this.opcoesFiltros[i]["opcoes"] = arg;
						}
					}
				});
		}
	}

	filtrar() {
		this.temFiltro = true;
		this.cancelarFiltros();
		this.fazBusca();
	}

	limparFiltros() {
		this.temFiltro = false;
		this.iniciaFiltros();
		this.cancelarFiltros();
		this.fazBusca();
	}
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts